<template>
  <v-row dense>
    <v-col cols="12" sm="3">
      <span class="caption font-weight-bold">Condição de pagamento</span>
      <div>
        {{ formData.CONDICAO_PAGAMENTO | truncate(45) }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
};
</script>
